module.exports = __webpack_public_path__ + "static/p3-6c39e2acc0fa5d629039156984dbad22.jpg";